import {Component, ContentChild, Input, OnInit, TemplateRef} from '@angular/core';
import {ListItemDirective} from '../../virtual-scroll/directives/list-item.directive';
import {DomSanitizer, SafeStyle} from '@angular/platform-browser';

@Component({
  selector: 'app-field-wrapper',
  templateUrl: './field-wrapper.component.html',
  styleUrls: ['./field-wrapper.component.scss']
})
export class FieldWrapperComponent implements OnInit {

  @Input() labelsWidth: string = '100px';
  @Input() noWrap: boolean = false;
  fieldsStyle: SafeStyle;

  constructor(public sanitizer: DomSanitizer) {
    this.sanitizer = sanitizer;
  }

  ngOnInit(): void {
    const fieldsStyle = `--label-width: ${this.labelsWidth}; --field-margin: ${this.noWrap ? '0px' : '5px'}; --field-width: ${this.noWrap ? '0px' : '10px'}`;
    this.fieldsStyle = this.sanitizer.bypassSecurityTrustHtml(fieldsStyle);
  }

}
